// extracted by mini-css-extract-plugin
export default {"main":"inputBorder__main__MA6ie","edi":"inputBorder__edi__WKarr","kasa":"inputBorder__kasa__PB7hx","kep":"inputBorder__kep__oT7WL","ttn":"inputBorder__ttn__IKoP_"};